<template>
    <div class="logo">
        <visual :svg="logo" />
    </div>
</template>

<script>
import Visual from 'gvue/src/core/Visual'

import getImage from '@/helpers/image'

export default {
    name: 'LogoN',
    components: { Visual },
    computed: {
        logo() {
            return getImage({
                type: 'icon',
                name: 'logo_n',
                landing: this.$landing
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
::v-deep .g_visual
    display: block
    height: pxToRem(72)
    width: pxToRem(72)
    fill: $color_black
</style>
